import { useNavigate, useLoaderData } from "react-router-dom";
import { useEffect } from "react";
import { redirectToLogin } from "../helper/common.helper";
import Unauthorized from "./Unauthorized";

const linkRedirect = {
	admin: "/admin/plans",
	reseller: "/reseller",
	organization: "/organization",
};

function HomeRedirect({ children }) {
	const { user, noSession } = useLoaderData();

	const navigate = useNavigate();

	const redirectTo = user ? linkRedirect[user.role] : null;

	if (noSession || (user?.role === "organization" && !user?.organization_id)) {
		redirectToLogin();
	}

	useEffect(() => {
		if (redirectTo) {
			navigate(redirectTo, { replace: true });
		}
	}, []);

	if (user && !redirectTo) {
		return <Unauthorized />;
	}

	return null;
}

export default HomeRedirect;
